// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { TipoArticuloProps } from '../../../interfaces/tipoArticulo.ts'
import { tipoArticuloFragment } from '../interfaces/fragment.ts'

const gqlQuery = gql`
  ${tipoArticuloFragment}
  query LISTADO($limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    tipoArticuloListado(limit: $limit, reverse: $reverse, page: $page, query: $query) {
      pageInfo {
        hasNextPage
        hasPrevPage
        totalDocs
        limit
        page
        totalPages
      }
      docs {
        ...tipoArticuloFragment
      }
    }
  }
`

/**
 * Respuesta de productos
 */
interface ApiTipoArticuloListadoResponse {
  docs: TipoArticuloProps[]
  pageInfo: PageInfoProps
}

/**
 * Listamos las unidades de medida simples sin el uso de filtros
 * @param pageInfo
 */
export const apiTipoArticuloListado = async (
  pageInfo: PageInputProps,
): Promise<ApiTipoArticuloListadoResponse> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(gqlQuery, { ...pageInfo })
    return data.tipoArticuloListado
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
